import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Global } from './shared/global.constants';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  public appConfig: any;
  darkKeys: any;
  outageNoticeDetails: any;
  regExToSearch: any;

  constructor(private http: HttpClient) { }

  /**
   * @description
   * This is a loadAppConfig function to return a promise for appConfig.json file
   *
   */
  async loadAppConfig(): Promise<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'No-Auth': 'True'
    });
    const data = await this.http.get('assets/data/appConfig.json', { headers })
      .toPromise();
    this.appConfig = data;
    this.regExToSearch = new RegExp(this.appConfig.EPAppId, 'gi');
    // from UI config
    if (this.appConfig.ServerDown) {
      this.outageNoticeDetails = this.appConfig.OutageOfflineText;
      sessionStorage.setItem('outage', 'true');
    } else {
      this.loadDarkFeatures().then(
        () => { },
        (err) => {
          console.log(err);
          if (err && err.error && err.error.apps && err.error.apps.search(this.regExToSearch) !== -1) {
            this.outageNoticeDetails = {
              startDt: err.error.startDate,
              endDt: err.error.endDate,
              maintenanceFlag: true,
              outageMessage: err.error.outageMessage,
              outageType: err.error.outageType
            };
            sessionStorage.setItem('outage', 'true');
          }
        }
      );
    }
  }
  /**
   * @description
   * This is a loadDarkFeatures function
   */
  async loadDarkFeatures(): Promise<any> {
    const reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'No-Auth': 'True'
    });
    const url = this.appConfig.API_URL + Global.BASE_GET_DARK_FEATURE_ENDPOINT;
    const data = await this.http.get(url, { headers: reqHeader })
      .toPromise();
    if (data['statusCode'] === 200 && data['result'] && data['result'].length > 0) {
      this.darkKeys = data['result'];
      this.darkKeys = this.darkKeys.filter((item: any) =>
        item.feature.search(/admin/gi) === -1);
      const account = this.darkKeys.find((x: any) => x.feature === 'Account' && x.enabled);
      const home = this.darkKeys.find((x: any) => x.feature === 'Home' && x.enabled);
      sessionStorage.setItem('DFLoaded', 'true');
      sessionStorage.setItem('uploadsFeature', account && !home ? 'true' : 'false');
      if (this.getDarkKeyValue(this.appConfig.OutageDFName)) {
        this.loadScheduledMaintenance().then(
          () => { },
          (err) => console.log(err)
        );
      } else {
        sessionStorage.setItem('outage', 'false');
      }
    } else if (data && data['statusCode'] === 422) {
      if (data['apps'] && data['apps'].search(this.regExToSearch) !== -1) {
        this.outageNoticeDetails = {
          startDt: data['startDate'],
          endDt: data['endDate'],
          maintenanceFlag: true,
          outageMessage: data['outageMessage'],
          outageType: data['outageType']
        };
        sessionStorage.setItem('outage', 'true');
      }
    }
  }

  /**
   * @description
   * This is a getScheduledMaintenance function
   */
  async loadScheduledMaintenance(): Promise<any> {
    const reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'No-Auth': 'True'
    });
    const url = this.appConfig.API_URL + Global.BASE_GET_SCHEDULED_MAINTANANCE_ENDPOINT;
    const data = await this.http.get(url, { headers: reqHeader })
      .toPromise();
    if (data && data['statusCode'] === 200 && data['result'] && data['result'].apps.search(this.regExToSearch) !== -1) {
      this.outageNoticeDetails = data['result'];
      sessionStorage.setItem('outage', 'true');
    } else {
      // from UI config
      if (!this.appConfig.ServerDown) {
        sessionStorage.setItem('outage', 'false');
      }
    }
  }

  /**
   * @description
   * This is a getConfig function to return appConfig variable value
   *
   */
  getConfig(): any {
    return this.appConfig;
  }

  /**
   * @description
   * This is a getScheduledMaintenance function to return outageNoticeDetails Object value
   */
  getScheduledMaintenance() {
    return this.outageNoticeDetails;
  }

  /**
   * @description
   * This is a getDarkKeyValue function to return boolean from the key values in dark feature object enabled
   */

  getDarkKeyValue(value: string): any {
    let canEnable = false;
    if (this.darkKeys === undefined) {
      return canEnable;
    }
    this.darkKeys.some((element: any) => {
      if (element.feature === value) {
        canEnable = element.enabled;
      }
    });
    return canEnable;
  }
}
